import { obtainTeamPrize } from '@/api/obtainTeamPrize';
import toast from '@kk/toast';

async function obtainPrize (startDate?: string) {
  try {
    const { code, message } = await obtainTeamPrize(startDate);
    if (code === 200) {
      toast.show({
        text: '领取成功',
        time: 2000
      });
    } else {
      toast.show({
        text: message,
        time: 2000
      });
    }
  } catch (error) {
    const errMSg = (error as Error).message || '服务器错误';
    toast.show({
      text: errMSg,
      time: 2000
    });
  }
}

export function useObtainPrize () {
  return obtainPrize;
}
